import {BreadCrumbs} from "../../../components/open/pages";
import '../../../static/css/pages/attend/attend.css';
import {Link} from "react-router-dom";
import {
    ThinAbsentIcon,
    ThinAutoExit,
    ThinChevronRight,
    ThinHistoryIcon
} from "../../../components/icons/material-icons";
import {useEffect} from "react";

export const AdminAttendOverviewScreen = () => {
    useEffect(() => {
        document.title = "حضورغیاب | نهال";
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'حضورغیاب', url: '/admins/attend'},
            ]}/>
            <div className="container" data-aos="fade-up" data-aos-duration="1000">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>حضورغیاب</b>
                            </div>
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <Link to={"/admins/attend/reports"} className="normal-list-tile">
                                        <div>
                                            <i><ThinHistoryIcon/></i>
                                            <div>
                                                <b>سابقه تردد</b>
                                                <span>گزارشات ورود و خروج کلیه دانش‌آموزان.</span>
                                            </div>
                                        </div>
                                        <ThinChevronRight/>
                                    </Link>
                                    <Link to={"/admins/attend/absents"} className="normal-list-tile">
                                        <div>
                                            <i><ThinAbsentIcon/></i>
                                            <div>
                                                <b>غایبین</b>
                                                <span>فهرست دانش‌آموزان غایب و ارسال پیامک غیبت.</span>
                                            </div>
                                        </div>
                                        <ThinChevronRight/>
                                    </Link>
                                    {/*<button className="normal-list-tile">*/}
                                    {/*    <div>*/}
                                    {/*        <i><ThinAutoExit/></i>*/}
                                    {/*        <div>*/}
                                    {/*            <b>خروج خودکار</b>*/}
                                    {/*            <span>تنظیمات مربوط به خروج خودکار همه دانش‌آموزان.</span>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*    <ThinChevronRight/>*/}
                                    {/*</button>*/}
                                </div>
                                <div className="col-lg-6 d-none d-lg-inline-block">
                                    <img src="/images/attend-card.jpg" style={{width: '100%',height:400,objectFit:'contain'}} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};